import axios from '@axios'

const state = () => ({
  catalog: {
    channels: [],
    categories: [],
    statsWindowDays: 30,
  },
  deliveries: {
    data: [],
    summary: {
      total: 0,
      sent: 0,
      failed: 0,
      skipped: 0,
    },
    meta: {
      pagination: {
        page: 1,
        per_page: 25,
        total_objects: 0,
      },
    },
  },
})

const getters = {
  notificationChannels(state) {
    return state.catalog.channels
  },
  notificationCategories(state) {
    return state.catalog.categories
  },
  notificationStatsWindowDays(state) {
    return state.catalog.statsWindowDays
  },
  notificationDeliveries(state) {
    return state.deliveries.data
  },
  notificationDeliveriesSummary(state) {
    return state.deliveries.summary
  },
  notificationDeliveriesPagination(state) {
    return state.deliveries.meta.pagination
  },
}

const mutations = {
  SET_NOTIFICATION_CATALOG(state, payload) {
    state.catalog = {
      channels: payload.channels || [],
      categories: payload.categories || [],
      statsWindowDays: payload.stats_window_days || 30,
    }
  },
  SET_NOTIFICATION_DELIVERIES(state, payload) {
    state.deliveries = {
      data: payload.data || [],
      summary: payload.summary || {
        total: 0, sent: 0, failed: 0, skipped: 0,
      },
      meta: payload.meta || { pagination: { page: 1, per_page: 25, total_objects: 0 } },
    }
  },
  SET_NOTIFICATION_CHANNEL_ENABLED(state, { eventKey, channel, enabled }) {
    state.catalog.categories.forEach(category => {
      category.events.forEach(event => {
        if (event.key !== eventKey) return
        event.channels.forEach(item => {
          if (item.channel === channel) {
            item.enabled = enabled
          }
        })
      })
    })
  },
}

const actions = {
  async fetchNotificationCatalog(context) {
    const response = await axios.get('/v1/notification_settings')
    context.commit('SET_NOTIFICATION_CATALOG', response.data)
    return response.data
  },

  async updateNotificationSetting(context, { eventKey, channel, enabled }) {
    context.commit('SET_NOTIFICATION_CHANNEL_ENABLED', { eventKey, channel, enabled })
    try {
      const response = await axios.put('/v1/notification_settings', {
        notification_setting: {
          event_key: eventKey,
          channel,
          enabled,
        },
      })
      return response.data
    } catch (error) {
      context.commit('SET_NOTIFICATION_CHANNEL_ENABLED', { eventKey, channel, enabled: !enabled })
      throw error
    }
  },

  async fetchNotificationDeliveries(context, params = {}) {
    const response = await axios.get('/v1/notification_deliveries', {
      params: {
        ...params,
        meta: {
          pagination: {
            page: params.page || 1,
            per_page: params.perPage || 25,
          },
        },
      },
    })
    context.commit('SET_NOTIFICATION_DELIVERIES', response.data)
    return response.data
  },

  async exportNotificationDeliveries(context, params = {}) {
    const response = await axios.get('/v1/notification_deliveries/export_csv', {
      params,
      responseType: 'blob',
    })
    return response.data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
